import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Alert,
  Divider,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ShareMenu = ({ anchorEl, setAnchorEl, playlistUrl }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleShare = (platform) => {
    let shareUrl = '';

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(playlistUrl)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(playlistUrl)}`;
        break;
      // case 'instagram':
      //   alert('Instagram does not support direct URL sharing via web. Share manually.');
      //   return;
      default:
        return;
    }

    window.open(shareUrl, '_blank');
    handleClose();
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(playlistUrl).then(() => {
      setSnackbarOpen(true);
      handleClose();
    });
  };

  return (
    <>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleCopyLink} sx={{ '&.Mui-focusVisible': { backgroundColor: 'transparent', outline: 'none', } }}>
          <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Copy Link</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleShare('facebook')}>
          <ListItemIcon><FacebookIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Facebook</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleShare('whatsapp')}>
          <ListItemIcon><WhatsAppIcon fontSize="small" /></ListItemIcon>
          <ListItemText>WhatsApp</ListItemText>
        </MenuItem>
        {/* <MenuItem onClick={() => handleShare('instagram')}>
          <ListItemIcon><InstagramIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Instagram</ListItemText>
        </MenuItem> */}

      </Menu>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ShareMenu;
